import Relay from 'react-relay';

export default {
  viewer: () => Relay.QL`query { agent(id: $userId) }`
};



/** WEBPACK FOOTER **
 ** ./src/queries/AgentIdQuery.js
 **/